import React, { Component, Suspense, useEffect, useContext, useState } from 'react';
import { Card, Button } from 'react-bootstrap'
import { useImmer } from 'use-immer';
import { ConditionalRender } from '../../controls/formControls';
import { AuthContext } from '../../contexts/AuthContext';
import { UserService, CustomerUserService } from '../../services'
import { userTypes } from '../../utilities/appConstants';
import moment from 'moment';

const validPhone = RegExp(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/i);

const formatDateTime = (date) => {
    const dt = moment(date)
    if (!dt.isValid()) {
        return 'Never';
    }
    let returnVal = '';
    const currDate = moment();
    const same = dt.isSame(currDate, 'day');
    const yesterday = dt.diff(currDate, 'days')
    if (same) {
        returnVal = dt.format('h:mm A') + ' today';
    } else {
        returnVal = dt.format('M/D/YY') + ' at ' + dt.format('h:mm A');
    }
    return returnVal;
}

const CustomerUsers = (props) => {
    const [userAccountId, setUserAccountId] = useImmer(0);
    const [userRoleId, setUserRoleId] = useImmer(0);
    const [userService, setUserService] = useState();
    const [canEdit, setCanEdit] = useState(false);

    const authContext = useContext(AuthContext);

    useEffect(() => {
        const accountId = parseInt(authContext.getClaim(authContext.claims.accountId));
        const roleId = authContext.getClaim(authContext.claims.userRole);
        setUserAccountId(accountId);
        setUserRoleId(roleId);
        let canEdit = false;
        if (props.userType == userTypes.contact) {
            canEdit = true;
        }
        if (props.userType == userTypes.customerUser) {
            const values = [authContext.claimValues.createReadUpdateDelete];
            const customerValues = [authContext.claimValues.isTrue]
            const canCreate = authContext.hasPermission(authContext.claims.canCrudAccounts, values);
            const canCustomerCreate = authContext.hasPermission(authContext.claims.isCustomerAdmin, customerValues)
            canEdit = canCreate || canCustomerCreate;
        }
        setCanEdit(canEdit);

        if (accountId > 1) {
            setUserService(new CustomerUserService());
        } else if (accountId == 1) {
            setUserService(new UserService());
        }
    }, []);
    const users = props.users;

    const showEditUser = async (id) => {
        var result = await userService.getUser(id);

        if (result && result.result) {
            props.showModal({
                open: true,
                userType: props.userType,
                model: result.model,
                closeModal: props.closeModal,
                saveModel: saveUser
            }, 'addUpdateCustomerUser')
        } else {
            // error
        }
    }

    const saveUser = async (user) => {
        let account = props.accounts ? props.accounts.find(e => e.id == user.accountId) : null
        user.accountName = account ? account.name : '';
        var result = user.id > 0 ?
            await userService.updateUser(user) :
            await userService.createUser(user);
        if (result.result) {
            // notify parent container of new user
            if (props.notifyUserChange != undefined) {
                props.notifyUserChange(result.model);
            }
        }
        return result;
    }

    return (
        <table className='table table-striped table-hover' aria-labelledby="tabelLabel">
            <thead>
                <tr>
                    <th>Name</th>
                    <ConditionalRender visible={props.userType == userTypes.customerUser}>
                        <th>Role</th>
                    </ConditionalRender>
                    <th>Email</th>
                    <th>Phone Number</th>
                    <th>Last Login</th>
                    <ConditionalRender visible={canEdit}>
                        <th className="table-fit">
                            <Button variant="primary" size="sm" onClick={() => props.showModal({
                                open: true,
                                model: { accountId: props.accountId, userType: props.userType },
                                accounts: props.accounts ? props.accounts : [],
                                closeModal: props.closeModal,
                                saveModel: saveUser
                            }, 'addUpdateCustomerUser')}>Create</Button>
                        </th>
                    </ConditionalRender>
                </tr>
            </thead>
            <tbody>
                {users.map((user) =>
                    <tr key={user.id}>
                        <td>{user.fullName}</td>
                        <ConditionalRender visible={props.userType == userTypes.customerUser}>
                            <td>
                                {user.roleName}
                                <ConditionalRender visible={user.accountName}>
                                    <br />{user.accountName}
                                </ConditionalRender>
                            </td>
                        </ConditionalRender>
                        <td><a href={"mailto: " + user.emailAddress}>{user.emailAddress}</a></td>
                        <td>{user.phoneNumber.replace(validPhone, "($1) $2-$3")}</td>
                        <td>{formatDateTime(user.lastLogin)}</td>
                        <ConditionalRender visible={canEdit}>
                            <td className="table-fit">
                                <Button variant="primary" size="sm" className="float-right" onClick={() => showEditUser(user.id)}>Edit</Button>
                            </td>
                        </ConditionalRender>
                    </tr>
                )}
            </tbody>
        </table>
    );
}

export default CustomerUsers;

//class CustomerUsers extends Component {
//    constructor(props, context) {
//        super(props, context);
//        this.state = {};

//        this.saveUser = this.saveUser.bind(this);
//        this.showEditUser = this.showEditUser.bind(this);
//    }

//    async showEditUser(id) {
//        var userService = new UserService();
//        var result = await userService.getUser(id);
//        if (result) {
//            this.props.showModal({
//                open: true,
//                model: result.model,
//                closeModal: this.props.closeModal,
//                saveModel: this.saveUser
//            }, 'addUpdateCustomerUser')
//        }
//    }

//    async saveUser(user) {
//        var userService = new UserService();
//        var result = user.id > 0 ?
//            await userService.updateUser(user) :
//            await userService.createUser(user);
//        if (result.result) {
//            // notify parent container of new user
//            if (this.props.notifyUserChange != undefined) {
//                this.props.notifyUserChange(result.model);
//            }
//        }
//        return result;
//    }



//    //async createUser(user) {
//    //    var userService = new UserService();
//    //    var result = await userService.createUser(user);
//    //    if (result.result) {
//    //        if (this.props.notifyUserChange != undefined) {
//    //            this.props.notifyUserChange(result.model);
//    //        }
//    //    }
//    //    return result;
//    //}

//    renderUserTable() {
//        return (
//            <table className='table table-striped table-hover' aria-labelledby="tabelLabel">
//                <thead>
//                    <tr>
//                        <th>Name</th>
//                        <th>Type</th>
//                        <th>Email</th>
//                        <th>Phone Number</th>
//                        <th className="table-fit">
//                            <Button variant="primary" size="sm" onClick={() => this.props.showModal({
//                                open: true,
//                                model: { accountId: this.props.accountId },
//                                closeModal: this.props.closeModal,
//                                saveModel: this.saveUser
//                            }, 'addUpdateCustomerUser')}>Create</Button>
//                        </th>
//                    </tr>
//                </thead>
//                <tbody>
//                    {this.props.users.map((user) =>
//                        <tr key={user.id}>
//                            <td>{user.fullName}</td>
//                            <td>{user.userTypeFriendly}</td>
//                            <td><a href={"mailto: " + user.emailAddress}>{user.emailAddress}</a></td>
//                            <td>{user.phoneNumber}</td>
//                            <td className="table-fit">
//                                <Button variant="primary" size="sm" onClick={() => this.showEditUser(user.id)}>Edit</Button>
//                            </td>
//                        </tr>
//                    )}
//                </tbody>
//            </table>
//        );
//    }

//    render() {
//        return (
//            <>
//                {this.renderUserTable()}
//            </>
//        );
//    }

//}

//export default CustomerUsers;